import type { MappedIconMicro } from "@/icons/icon-mapping-micro";
import type { EditorMode } from "@/types/email";

export const EDITOR_MODES: Record<
  EditorMode,
  { label: string; icon: MappedIconMicro }
> = {
  fancy: { label: "Fancy mode", icon: "sparkles" },
  naked: { label: "Naked mode", icon: "file-code" },
  plaintext: { label: "Markdown mode", icon: "code-bracket" },
};
